import {
    CHANGE_AUTO_SYNC,
    EMainViewMode,
    EPlayMode,
    IGeneralActions,
    IGeneralState,
    IOneTimeTooltips,
    IRouteOnLogin,
    ISetAppSettingsAction,
    ISetAudioPlayerState,
    ISetAuthUser,
    ISetAutoPause,
    ISetHoverAutoPause,
    ISetLibraryGroupId,
    ISetMainViewMode,
    ISetOneTimeTooltip,
    ISetPauseOnNoteAction,
    ISetPlayerRate,
    ISetPlayMode,
    ISetRouteOnLoginAction,
    ISetShowNativeCaptions,
    ISetShowTranslations,
    ISetSnackbarPanelAction,
    ISetVideoWatchTodayAction,
    ISyncUserLocalStorageData,
    IUpdateGeneral,
    SET_APP_SETTINGS,
    SET_AUDIO_PLAYER_STATE,
    SET_AUTH_USER,
    SET_AUTO_PAUSE_SIZE,
    SET_HOVER_AUTO_PAUSE,
    SET_LIBRARY_GROUP,
    SET_MAIN_VIEW_MODE,
    SET_ONE_TIME_TOOLTIP,
    SET_PAUSE_ON_NOTE,
    SET_PLAY_MODE,
    SET_PLAYER_RATE,
    SET_ROUTE_ON_LOGIN,
    SET_SHOW_NATIVE_CAPTIONS,
    SET_SHOW_TRANSLATIONS,
    SET_SNACKBAR_PANEL,
    SET_VIDEO_WATCH_TODAY,
    SYNC_USER_LOCAL_STORAGE,
    TAuthUser,
    UPDATE_GENERAL
} from './types';
import { AudioPlayerStates } from '../../types/common';
import { IAppSettings } from '../../../common/rest/user/userRest';

export const syncUserLocalStorageAction = (
  data: ISyncUserLocalStorageData
): IGeneralActions => ({
    type: SYNC_USER_LOCAL_STORAGE,
    data
})

export const changeAutoSyncAction = (
    state: boolean
): IGeneralActions => ({
    type: CHANGE_AUTO_SYNC,
    state
})

export const setAuthUserAction = (
    user: TAuthUser | null
): ISetAuthUser => ({
    type: SET_AUTH_USER,
    user
})

export const setAutoPauseAction = (
    pause: number
): ISetAutoPause => ({
    type: SET_AUTO_PAUSE_SIZE,
    pause
});

export const setHoverAutoPauseAction = (
  hoverAutoPause: boolean
): ISetHoverAutoPause => ({
    type: SET_HOVER_AUTO_PAUSE,
    hoverAutoPause
});

export const setLibraryGroupIdAction = (
    groupId: number | null
): ISetLibraryGroupId => ({
    type: SET_LIBRARY_GROUP,
    groupId
});

export const setAudioPlayerState = (
  state: AudioPlayerStates
): ISetAudioPlayerState => ({
    type: SET_AUDIO_PLAYER_STATE,
    state
});

export const setPlayerRate = (
    rate: number
): ISetPlayerRate => ({
    type: SET_PLAYER_RATE,
    rate
});

export const setPlayMode = (
    mode: EPlayMode
): ISetPlayMode => ({
    type: SET_PLAY_MODE,
    mode
});

export const setOneTimeTooltipAction = (
  value: Partial<IOneTimeTooltips>
): ISetOneTimeTooltip => ({
    type: SET_ONE_TIME_TOOLTIP,
    value,
});

export const setMainViewMode = (
  mainViewMode: EMainViewMode
): ISetMainViewMode => ({
    type: SET_MAIN_VIEW_MODE,
    mainViewMode
});

export const setShowNativeCaptionsAction = (
  show: boolean
): ISetShowNativeCaptions => ({
    type: SET_SHOW_NATIVE_CAPTIONS,
    show
});

export const setSnackbarPanelAction = (
  show: boolean, text?: string
): ISetSnackbarPanelAction => ({
    type: SET_SNACKBAR_PANEL,
    show,
    text: text || ''
});

export const setAppSettingsAction = (
  value: Partial<IAppSettings>
): ISetAppSettingsAction => ({
    type: SET_APP_SETTINGS,
    value
});

export const setPauseOnNoteAction = (
  pauseOnNote: boolean
): ISetPauseOnNoteAction => ({
    type: SET_PAUSE_ON_NOTE,
    pauseOnNote
});

export const setRouteOnLoginAction = (
  data: Partial<IRouteOnLogin>
): ISetRouteOnLoginAction => ({
    type: SET_ROUTE_ON_LOGIN,
    data
});

export const setVideoWatchTodayAction = (
  videoWatchToday: number
): ISetVideoWatchTodayAction => ({
    type: SET_VIDEO_WATCH_TODAY,
    videoWatchToday,
});

export const setShowTranslationsAction = (
  value: boolean
): ISetShowTranslations => ({
    type: SET_SHOW_TRANSLATIONS,
    value,
});

export const updateGeneralAction = (
  value: Partial<IGeneralState>
): IUpdateGeneral => ({
    type: UPDATE_GENERAL,
    value,
});
